import { OPERATION_LOG_UPLOAD_SIZE_LIMIT_BYTES } from "../config/operationLogUpload";

/**
 * 操作ログファイルがアップロードサイズ制限（10MB）以上かどうかを判定する。
 * @param file 対象の File
 * @returns 10MB以上なら true、未満なら false
 */
export function is_operation_log_file_size_over_limit(file: File): boolean {
  return file.size >= OPERATION_LOG_UPLOAD_SIZE_LIMIT_BYTES;
}
